module.exports = __webpack_public_path__ + "media/newstyle/images/stars_sprint-4767b9d5fc499750dc232e367c393ff3.png";